<template>
  <div>
    <button
      type="button"
      class="px-3 py-2 rounded-md border-2 border-primary flex md:hidden items-center gap-3"
      @click="isOpenMobile = !isOpenMobile"
    >
      <font-awesome-icon icon="filter" class="text-slate-700" />
      <span>{{ isOpenMobile ? "Hide" : "Show" }} filters</span>
    </button>

    <div
      class="w-full grid-cols-2 md:grid-cols-4 gap-5 mt-5"
      :class="isOpenMobile ? 'grid' : 'hidden md:grid'"
    >
      <ais-menu-select attribute="vehicleBrand" :limit="1000">
        <template v-slot="{ items, refine }">
          <ApplicationFilter
            label="Make"
            v-model="selectedVehicleBrand"
            :items="items"
            :refine="refine"
          />
        </template>
      </ais-menu-select>

      <ais-menu-select attribute="vehicleModel" :limit="1000">
        <template v-slot="{ items, refine }">
          <ApplicationFilter
            label="Model"
            v-model="selectedVehicleModel"
            :items="items"
            :refine="refine"
          />
        </template>
      </ais-menu-select>

      <ais-menu-select attribute="vehicleIdentifier" :limit="1000">
        <template v-slot="{ items, refine }">
          <ApplicationFilter
            label="Trim"
            v-model="selectedVehicleIdentifier"
            :items="items"
            :refine="refine"
          />
        </template>
      </ais-menu-select>

      <ais-menu-select attribute="year" :limit="1000">
        <template v-slot="{ items, refine }">
          <ApplicationFilter
            label="Year"
            v-model="selectedYear"
            :items="items"
            :refine="refine"
          />
        </template>
      </ais-menu-select>

      <ais-menu-select attribute="job" :limit="1000" class="col-span-full">
        <template v-slot="{ items, refine }">
          <ApplicationFilter
            label="Service"
            v-model="selectedService"
            :items="items"
            :refine="refine"
          />
        </template>
      </ais-menu-select>
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from "vue";
import { AisMenuSelect } from "vue-instantsearch/vue3/es";
import ApplicationFilter from "./ApplicationFilter.vue";

const isOpenMobile = ref(false);

function getFilterValueFromUrl(key) {
  const url = new URL(window.location.href);
  const searchParams = url.searchParams;
  return searchParams.get(`menu[${key}]`) ?? "";
}

const selectedVehicleBrand = ref(getFilterValueFromUrl("vehicleBrand"));
const selectedVehicleModel = ref(getFilterValueFromUrl("vehicleModel"));
const selectedVehicleIdentifier = ref(
  getFilterValueFromUrl("vehicleIdentifier")
);
const selectedYear = ref(getFilterValueFromUrl("year"));
const selectedService = ref(getFilterValueFromUrl("job"));

watch(selectedVehicleBrand, (val) => {
  if (val !== "") return;
  selectedVehicleModel.value = "";
  selectedVehicleIdentifier.value = "";
  selectedYear.value = "";
});

watch(selectedVehicleModel, (val) => {
  if (val !== "") return;
  selectedVehicleIdentifier.value = "";
  selectedYear.value = "";
});

watch(selectedVehicleIdentifier, (val) => {
  if (val !== "") return;
  selectedYear.value = "";
});
</script>
